module.exports = __webpack_public_path__ + "models/tutor3.76d75a7.txt";